const firebaseConfig = {
  apiKey: "AIzaSyALOiLKq-dgrrb_1GHDZFxIPlMIxKhvESA",
  authDomain: "apperment-hunt.firebaseapp.com",
  databaseURL: "https://apperment-hunt.firebaseio.com",
  projectId: "apperment-hunt",
  storageBucket: "apperment-hunt.appspot.com",
  messagingSenderId: "258104595449",
  appId: "1:258104595449:web:54e98d5af16e8328ef6328"
};
export default firebaseConfig;